// La prioridad de una incidencia de calidad y la clave i18n con la que se rotula (T12 de la historia
// 160). Vive aquí, fuera del proveedor del widget, porque el detalle del job de MOS pinta la misma
// prioridad con las mismas claves: una sola tabla, dos lectores (R-16).

export const QUALITY_INCIDENCE_PRIORITY_OPTIONS = [
  { value: 'LOW', labelKey: 'Low' },
  { value: 'MEDIUM', labelKey: 'Medium' },
  { value: 'HIGH', labelKey: 'High' },
  { value: 'CRITICAL', labelKey: 'Critical' }
]

/** P19 (historia 204): las mismas claves, como `labelKeys` del ayudante de valores de sistema. */
export const QUALITY_INCIDENCE_PRIORITY_LABEL_KEYS = Object.fromEntries(
  QUALITY_INCIDENCE_PRIORITY_OPTIONS.map(({ value, labelKey }) => [value, labelKey])
)

/** La clave i18n de una prioridad (`LOW`…`CRITICAL`); el valor tal cual si no es conocida. */
export const priorityLabelKey = (value = '') => {
  const option = QUALITY_INCIDENCE_PRIORITY_OPTIONS.find((candidate) => candidate.value === value)
  return option ? option.labelKey : value
}
